import React from 'react'
import styled from 'styled-components'

const ProgressBar = styled.progress`
  &[value] {
    position: relative;
    display: inline-block;

    /* You can control ProgressBar with either 'width' or 'spacing' properties */
    ${props => props.width && !props.spacing && `
      width: ${props.width}px;
    `}

    /* Make room for the time texts */
    ${props => props.spacing && !props.width && `
      width: calc(100% - ${2 * props.spacing}px);
    `}

    height: 6px;

    /* Reset the default appearance */
    -webkit-appearance: none;
    appearance: none;
  }

  /* The progress bar itself */
  &::-webkit-progress-bar {
    border-radius: 7px;
    background-color: #4D4D4D;

    /* clip the value's shadow so that it's only visible on the progress bar itself. So that it doesn't spill onto the parent */
    overflow: hidden;
  }

  /* The current progress */
  &::-webkit-progress-value {
    border-radius: 7px;
    background-color: ${props => props.progressColor ? props.progressColor : 'black'};

    ${props => props.shadow && `
      box-shadow: 3px 0px 0px #232323;
    `}
  }
`

export default ProgressBar



// WEBPACK FOOTER //
// ./src/components/visuals/ProgressBar.js